"use client"; // Error components must be Client Components

import { useEffect } from "react";
import { useAnalytics } from "./components/AnalyticsProvider";

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  const analytics = useAnalytics();

  // If the error is an error object that has a message, we can log it
  const errorMessage = error instanceof Error && error.message ? error.message : undefined;

  useEffect(() => {
    analytics.triggerErrorReport(error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <html>
      <body>
        <h2>Something went wrong!</h2>
        <p>An error has occurred that we could not recover from.</p>
        {errorMessage && <p>Error details: {errorMessage}</p>}
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  );
}
